import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { autoHide: Number }

  connect() {
    // Auto-hide after specified time (in milliseconds)
    if (this.hasAutoHideValue && this.autoHideValue > 0) {
      this.autoHideTimeout = setTimeout(() => {
        this.dismiss()
      }, this.autoHideValue)
    }
  }

  dismiss() {
    // Fade out animation
    this.element.style.transition = "opacity 0.3s ease-out"
    this.element.style.opacity = "0"

    // Remove element after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  disconnect() {
    // Clear timeout if exists
    if (this.autoHideTimeout) {
      clearTimeout(this.autoHideTimeout)
    }
  }
}